import './index.scss'
$("#nav8").addClass("active");